<template>
    <ContentOrLoading>
        <div class="ml-3 mr-3" v-if="!loading">
            <transition name="fade" mode="out-in">
                <div class="row" :style="!svgRendered && loadingSvg ? 'padding: 50px;' : ''" key="mapa-butacas" id="paso-1">
                    <div class="col-12 mb-2 p-0 d-md-flex d-block justify-content-between">
                        <h3 v-if="svgRendered && !loadingSvg">Seleccione las butacas:</h3>
                    </div>
                    <div class="lightgray-content col-12 col-md-8 p-2">
                        <ContentOrLoading>
                            <LeafletComponent
                                v-if="svgRendered && !loadingSvg"
                                :svgRendered="svgRendered"
                                :originalColor="originalColor"
                                :disabled="!paso_activo"
                                @isPanning="(e) => isPanning = e"
                            />
                        </ContentOrLoading>
                    </div>
                    <div class="col-12 col-md-4 mt-3" v-if="butacasSeleccionadas && butacasSeleccionadas.length > 0">
                        <b-card class="scrollable-container">
                            <div class="d-block text-center d-md-flex justify-content-between align-items-center mb-3 pl-3 pr-3">
                                <h3>TUS BUTACAS</h3>
                                <Button @click="showModalBloquearButacas()" :disabled="!paso_activo || butacasSeleccionadas.length == 0">BLOQUEAR / LIBERAR BUTACAS</Button>
                            </div>
                            <div class="overflow-auto col-12 text-center" style="max-height: 446px;">
                                <div v-for="(butaca, index) in butacasSeleccionadas" :key="index">
                                    <TusPlazasComponent :butaca="butaca" :region-seleccionada="regionSeleccionada" :index="index" :disabled="!paso_activo" @borrar-plaza="borrarPlaza(butaca)" />
                                </div>
                                <div v-if="teatro.carrito_varios_eventos" class="d-flex flex-row justify-content-center mt-3">
                                    <template v-if="(carrito && carrito.items_count == 0) || !carrito">
                                        <Button @click="bloquearButacas()" class="btn btn-primary mb-2 mb-md-0 me-md-2 mr-1" :disabled="!paso_activo" style="flex: 1;">CONTINUAR COMPRA</Button>
                                        <Button id="add-cart" @click="checkCarrito()" class="btn btn-secondary ml-0 ml-md-1 mr-1 mr-md-0 mb-2 mb-md-0" :disabled="!paso_activo || disableButtonCart"><i class="fa fa-cart-plus" aria-hidden="true"></i></Button>
                                    </template>
                                    <Button id="add-cart" v-else @click="checkCarrito()" class="btn btn-secondary ml-0 ml-md-1 mr-1 mr-md-0" :disabled="!paso_activo || disableButtonCart" style="flex: 1;">AÑADIR AL CARRITO</Button>
                                </div>
                                <Button v-else @click="bloquearButacas()" class="btn-block" :disabled="!paso_activo">CONTINUAR COMPRA</Button>
                            </div>
                        </b-card>
                    </div>
                    <template v-if="svgRendered && !loadingSvg">
                        <LeyendaColorEventos class="mt-4" />
                        <div class="col-12 d-md-flex align-items-center mt-4" v-if="svgRendered && !loadingSvg">
                            <div>
                                <FormInput label="Número de butacas" type="number" name="n_butacas" max="100" v-model="n_butacas" />
                            </div>
                            <div class="ml-3">
                                <Button class="m-1" @click="selectButacas" :disabled="(n_butacas === 0 || n_butacas > 100) || !paso_activo">Seleccionar</Button>
                                <Button class="m-1" @click="selectAllButacas" :disabled="!paso_activo">Seleccionar todas</Button>
                                <Button class="m-1" @click="clearButacas" :disabled="butacasSeleccionadas.length == 0 || !paso_activo">Borrar selección</Button>
                            </div>
                        </div>
                    </template>
                </div>
            </transition>
            <ModalRegionSinNumerar
                v-if="showModalRegionSinNumerar"
                :precios="preciosSeleccionados"
                :regionSeleccionada="regionSeleccionada"
                @setAsientos="(asientos) => setAsientos(asientos)"
                @close="closeModal"
            />
            <BloquearButacas
                v-if="butacasSeleccionadas.length > 0 && paso_activo"
                :butacas="butacasSeleccionadas"
                @bloquearButacas="bloquearButacasManual"
                @close="closeModalBloquearButacas"
            />
        </div>
    </ContentOrLoading>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import ModalRegionSinNumerar from './ModalRegionSinNumerar.vue';
    import LeyendaColorEventos from '@/views/backend/events/sesiones/bloquear-asientos/LeyendaColorEventos.vue';
    import TusPlazasComponent from './TusPlazasComponent.vue';
    import BloquearButacas from './BloquearButacas.vue';
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: ['recinto_id', 'paso_activo', 'loading'],
        data() {
            return {
                loadingSvg: false,
                butacas: null,
                butacasSeleccionadas: [],
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                seleccionadaColor: '#8CA9D9',
                bloqueadaEventosColor: '#BF95C4',
                bloqueadaAbonosColor: 'purple',
                vendidaAbonosColor: 'black',
                vendidaEventosColor: 'red',
                enSesionEventosColor: 'yellow',
                enSesionAbonosColor: 'orange',
                abonadoNoRenovadoColor: '#B05D04',
                validadaControlAccesoColor: '#01018A',
                svgRendered: null,
                isPanning: null,
                session_id: null,
                svg: '',
                regiones: null,
                preciosSeleccionados: [],
                showModalRegionSinNumerar: false,
                regionSeleccionada: null,
                n_butacas: 0,
                disableButtonCart: false
            }
        },
        methods: {
            setAsientos(asientos) {
                asientos.forEach(asiento => {
                    this.butacasSeleccionadas.push(asiento);
                });

                this.bloquearButacas();
            },
            borrarPlaza(plaza) {
                this.clickButaca(plaza.id);
                const butaca = document.querySelector(`[id^="butaca-${plaza.svg_id}-"]`);
                butaca.setAttribute('fill', this.originalColor);
                butaca.setAttribute('seleccionado', 'false');
            },
            bloquearButacas() {
                this.updateLoading(true);
                let data;
                if (!this.regionSeleccionada) {
                    data = this.butacasSeleccionadas.map(butaca => {
                        return {
                            'plazaId': butaca.id,
                        }
                    });
                } else {
                    data = this.butacasSeleccionadas.map(butaca => {
                        return {
                            'asiento': butaca.asiento,
                            'fila': butaca.fila,
                            'zona_id': butaca.zona_id,
                            'zona_nombre': butaca.zona_nombre
                        }
                    });
                }

                const params = {
                    filters: {},
                    event_id: this.evento_id,
                    sesion_id: this.sesion_id,
                };

                let url;
                if (this.regionSeleccionada) {
                    url = 'front.bloquear.asientos';
                    params.zona_id = this.regionSeleccionada.id;
                    params.asientos = data;
                } else {
                    url = 'back.event.sesiones.recinto.taquilla.bloquear-plazas';
                    params.recinto_id = this.recinto_id;
                    params.data = data;
                }


                this.$store.dispatch(this.config.getVuexAlias(url), params).then(res => {
                    this.session_id = res.data.session_id;
                    this.$emit('goTo', 3, this.butacasSeleccionadas, this.session_id, true)
                }).catch(error => {
                    if (error?.response?.data?.message === 'Plazas ocupadas') {
                        this.$toast.error('Plazas ocupadas');
                        this.butacasSeleccionadas = [];
                        this.svgRendered = null;
                        this.getButacas();
                    } else {
                        console.error('Error al bloquear las butacas');
                    }
                });
            },
            getSvg() {
                this.updateLoading(true);
                this.loadingSvg = true;
                const params = {
                    filters: {},
                    recinto_id: this.recinto_id
                }

                this.$store.dispatch(this.config.getVuexAlias('recinto.svg'), params).then(res => {
                    this.svg = res.data.svg;
                    this.renderLeafletSvg(this.svg);
                    this.updateLoading(false);
                    this.loadingSvg = false;
                }).catch(error => {
                    console.log(error);
                    console.error('Error al recuperar el svg');
                });
            },
            getButacas() {
                this.updateLoading(true);

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    recinto_id: this.recinto_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.butacas'), params).then(res => {
                    this.butacas = res.data.data;
                    this.getSvg();
                    this.updateLoading(false);
                }).catch(() => {
                    console.error('Error al recuperar las butacas');
                });
            },
            getRegionesSinNumerar() {
                this.updateLoading(true);

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    recinto_id: this.recinto_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-sin-asientos'), params).then(res => {
                    this.regiones = res.data.data;
                }).catch(() => {
                    console.error('Error al recuperar las butacas');
                }).finally(() => {
                    this.updateLoading(false);
                });
            },
            renderLeafletSvg(svg) {
                const butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);
                const regionesFiltered = this.regiones.filter(region => region.svg_id);

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
                const regiones = svgElement.querySelectorAll('[id^="region"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);
                
                
                    if (butaca) {
                        const title = this.getButacaName(butaca);

                        if (butaca.libre && butaca.precios && butaca.precios.length > 0) {
                            let content = '';
                            content += 'Disponible';
                            content += `<span class="d-block">Desde: ${this.generatePriceContent(butaca.precios)}</span>`
                            this.drawPopover(circle, content, title);
                            circle.setAttribute('fill', this.originalColor);
                
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s'
    
                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                setTimeout(() => {
                                    if (!this.isPanning && this.paso_activo) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickButaca(butaca.id);
                                    }
                                }, 150);
                            });
                        } else if (butaca.ocupada && butaca.ocupada.venta && butaca.info_acceso && butaca.info_acceso.accedido) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.validadaControlAccesoColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, '', title,  butaca ); 
                        } else if (!butaca.libre && butaca.precios && butaca.precios.length > 0 && butaca.ocupada) {
                            if (butaca.ocupada.venta) {
                                var texto = '<div><strong>Vendida</strong></div>';
                                if (butaca.info_ocupada) {
                                    if (butaca.info_ocupada.numero_pedido) {
                                        texto += '<div><strong>Nº del pedido:</strong> ' + butaca.info_ocupada.numero_pedido + '</div>';

                                        circle.addEventListener('click', () => {
                                            let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${butaca.info_ocupada.numero_pedido}`;
                                            window.open(url, '_blank');
                                        });
                                    }
                                    if (butaca.info_ocupada.nombre_venta && butaca.info_ocupada.apellidos_venta) texto += '<div><strong>Nombre:</strong> ' + butaca.info_ocupada.nombre_venta + ' ' + butaca.info_ocupada.apellidos_venta + '</div>';
                                }
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaEventosColor);
                                circle.style.cursor = 'not-allowed';
                                let contenido  = 'Vendida en eventos';
                                if (butaca.info_ocupada) {
                                    if (butaca.info_ocupada.numero_pedido) {
                                        contenido += '</br><div><strong>Nº del pedido: </strong>' + butaca.info_ocupada.numero_pedido + '</div>';
                                    }
                                    if(butaca.info_acceso.accedido){
                                        contenido += '</br><div><strong>Hora de acceso: </strong>' + butaca.info_acceso.hora_acceso + '</div>';
                                    }
                                    if (butaca.info_ocupada.nombre_venta && butaca.info_ocupada.apellidos_venta) {
                                        contenido += `<div><strong>Nombre: </strong>${butaca.info_ocupada.nombre_venta + ' ' + butaca.info_ocupada.apellidos_venta}</div>`;
                                    }
                                }
                                this.drawPopover(circle, contenido, title);
                            } else if (butaca.ocupada.comprada_abonos && butaca.ocupada.renovado) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaAbonosColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, 'Vendida en abonos', title); 
                            } else if (butaca.ocupada.sesion) {
                                circle.setAttribute('ocupada', 'true');
                                circle.style.cursor = 'not-allowed';
                                circle.setAttribute('fill', this.enSesionEventosColor);
                                this.drawPopover(circle, 'En sesión', title); 
                            }else if (butaca.ocupada.bloqueada) {
                                if (butaca.ocupada.reserva_id) {
                                    circle.setAttribute('ocupada', 'true');
                                    circle.style.cursor = 'not-allowed';
                                    circle.setAttribute('fill', this.bloqueadaEventosColor);
                                    this.drawPopover(circle, 'Reservada', title); 
                                } else {
                                    let texto = `<strong>Bloqueada</strong>`;
                                    if (butaca.etiqueta_bloqueo) {
                                        texto += `<div><strong>` + butaca.etiqueta_bloqueo.name + `</strong></div>`;
                                    }
                                    if (butaca.info_ocupada?.concepto) {
                                        texto += `<div><strong>Concepto: </strong>` + butaca.info_ocupada.concepto + `</div>`
                                    }
                                    this.drawPopover(circle, texto, title); 
                                    circle.setAttribute('fill', this.bloqueadaEventosColor);

                                    if (this.checkDisponibilidad(butaca)) {
                                        butaca.libre = true;
                                    }
                                    circle.addEventListener('click', () => {
                                        let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
        
                                        setTimeout(() => {
                                            if (!this.isPanning) {
                                                if (!isSeleccionado) {
                                                    circle.setAttribute('fill', this.seleccionadaColor);
                                                    circle.setAttribute('seleccionado', 'true');
                                                } else {
                                                    if (butaca.etiqueta_bloqueo) {
                                                        circle.setAttribute('fill', butaca.etiqueta_bloqueo.color);
                                                    } else {
                                                        circle.setAttribute('fill', this.bloqueadaEventosColor);
                                                    }
                                                    circle.setAttribute('seleccionado', 'false');
                                                }
                                                this.clickButaca(butaca.id);
                                            }
                                        }, 150);
                                    }); 
                                }
                                if (butaca.etiqueta_bloqueo) {
                                    circle.setAttribute('ocupada', 'true');
                                    circle.setAttribute('fill', butaca.etiqueta_bloqueo.color);
                                    this.drawPopover(circle, butaca.etiqueta_bloqueo.name, title); 
                                }
                            } else if (butaca.ocupada.bloqueada_abonos) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.bloqueadaAbonosColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, 'Bloqueada en abonos', title); 
                            } 
                        } else {
                            this.drawPopover(circle, 'No disponible', title);
                            circle.setAttribute('no-disponible', 'true');
                            circle.setAttribute('fill', this.noDisponibleColor);
                            circle.style.fill = 'gray';
                        }

                        if(!this.paso_activo) {
                            circle.style.pointerEvents = 'none';
                        }
                    }
                });

                regiones.forEach(element => {
                    const svg_id = this.getButacaId(element);
                    const region = regionesFiltered.find(region => region.svg_id == svg_id);

                    if (region) {
                        if (region.libres > 0 && region.precios.length > 0) {
                            const content = this.getRegionPrecio(region);
                            this.drawPopover(element, content, region.nombre);
    
                            element.addEventListener('click', () => {
                                if (!this.continuarConCompra) {
                                    const popover = document.querySelector('.popover');
                                    if (popover) {
                                        popover.remove();
                                    }
                                    this.regionSeleccionada = region;
                                    this.butacas.forEach(butaca => {
                                        return butaca.seleccionada = false;
                                    });
                                    this.butacasSeleccionadas = [];
                                    this.showModalEntradas(region.precios);                                
                                }
                            });
                        } else if (region.libres <= 0 && region.precios.length > 0) {
                            element.style.fill = 'red';
                            element.style.cursor = 'disabled';
                            this.drawPopover(element, 'Entradas agotadas', region.nombre);
                        } else {
                            element.style.fill = 'gray';
                            element.style.cursor = 'disabled';
                            this.drawPopover(element, 'No disponible', region.nombre);
                        }

                        if(!this.paso_activo) {
                            element.style.pointerEvents = 'none';
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            clearButacas() {
                this.butacas.forEach(butaca => {
                    if(butaca.seleccionada) {
                        const butaca_plano = document.querySelector(`[id^="butaca-${butaca.svg_id}-"]`);
                        if (butaca_plano) {
                            butaca_plano.setAttribute('fill', this.originalColor);
                            butaca_plano.setAttribute('seleccionado', 'false');
                            delete butaca.seleccionada;
                        }
                    }
                });
                this.butacasSeleccionadas = [];
            },
            selectButacas() {
                var count = this.n_butacas <= 100 ? this.n_butacas : 100;

                this.butacas.forEach(butaca => {
                    if(!butaca.seleccionada && butaca.precios.length > 0 && (butaca.libre || butaca.disponible) && count > 0) {
                        this.clickButaca(butaca.id);
                        count--;

                        const butacaElement = document.querySelector(`[id^="butaca-${butaca.svg_id}-"]`);
                        if (butacaElement) {
                            butacaElement.setAttribute('fill', this.seleccionadaColor);
                            butacaElement.setAttribute('seleccionado', 'true');
                            butaca.seleccionada = true;
                        }
                    }
                });
            },
            selectAllButacas() {
                var count = 0;

                this.butacas.forEach(butaca => {
                    if(!butaca.seleccionada && butaca.precios.length > 0 && (butaca.libre || butaca.disponible) && count < 100) {
                        this.clickButaca(butaca.id);

                        const butacaElement = document.querySelector(`[id^="butaca-${butaca.svg_id}-"]`);
                        if (butacaElement) {
                            butacaElement.setAttribute('fill', this.seleccionadaColor);
                            butacaElement.setAttribute('seleccionado', 'true');
                            butaca.seleccionada = true;
                        }

                        count++;
                    }
                });
            },
            clickButaca(butaca_id) {
                let butacaSeleccionada = this.butacas.find(butaca => butaca.id == butaca_id);
                if (butacaSeleccionada && this.paso_activo) {
                    butacaSeleccionada.seleccionada = butacaSeleccionada?.seleccionada && butacaSeleccionada.seleccionada ? false : true;
                    butacaSeleccionada.sin_sector = true;
                    if (butacaSeleccionada.seleccionada) {
                        this.butacasSeleccionadas.push(butacaSeleccionada);
                    } else {
                        const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id == butacaSeleccionada.id);
                    
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                        }
                    }
                }
            },
            getRegionPrecio(region) {
                const lowestPrice = region.precios.reduce((lowest, current) => {
                    const currentPrice = parseFloat(current.precio);
                    if (!lowest || currentPrice < lowest) {
                        return currentPrice;
                    }

                    return lowest;
                }, null);

                return `Desde: ${lowestPrice}€`;
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> ' + this.textoVisibilidadReducida + '</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            drawPopover(circle, content = '', title = null, butaca = null) {
                if (butaca) {
                    if (butaca.precios.length === 0) {
                        content += `<div><strong>No disponible</strong></div>`;
                    } else if ((butaca.disponible || butaca.libre) && butaca.precios.length > 0) {
                        content += `<div><strong>Disponible</strong></div>`;
                        content += `Desde: ${this.$n(this.generatePriceContent(butaca.precios), "currency")}`;
                    }

                    if (butaca.ocupada) {
                        if (butaca.etiqueta_bloqueo) {
                            content += `<div><strong>` + butaca.etiqueta_bloqueo.name + `</strong></div>`;
                        }
                        if (butaca.ocupada.reserva_id) {
                            content += `<div><strong>Reservada</strong></div>`;
                        } else if (butaca.ocupada.bloqueada) {
                            content += `<div><strong>Butaca bloqueada</strong></div>`;
                        } else if (butaca.ocupada.bloqueada_abonos) {
                            content += `<div><strong>Butaca bloqueada en abonos</strong></div>`;
                        }
                        if (butaca.ocupada.venta) {
                            content += `<div><strong>Vendida</strong></div>`;
                            if (butaca.info_ocupada) {
                                if (butaca.info_ocupada.numero_pedido) {
                                    content += '<div><strong>Nº del pedido: </strong>' + butaca.info_ocupada.numero_pedido + '</div>';
                                }
                                if(butaca.info_acceso.accedido){
                                    content += '<div><strong>Hora de acceso: </strong>' + butaca.info_acceso.hora_acceso + '</div>';
                                }
                                if (butaca.info_ocupada.nombre_venta && butaca.info_ocupada.apellidos_venta) {
                                    content += `<div><strong>Nombre: </strong>${butaca.info_ocupada.nombre_venta + ' ' + butaca.info_ocupada.apellidos_venta}</div>`;
                                }
                            }
                        }
                        if (butaca.ocupada.comprada_abonos) {
                            content += `<div><strong>Vendida en abonos</strong></div>`;

                            if (butaca.info_ocupada?.numero_abonado && !butaca.ocupada.renovado) {
                                content += `<div><strong>Abonado no renovado</strong></div>`;
                            }
                        }
                        if (butaca.ocupada.sesion) {
                            content += `<div><strong>En sesión</strong></div>`;
                        }
                        if (butaca.ocupada.en_sesion_abonos) {
                            content += `<div><strong>En sesión en abonos</strong></div>`;
                        }
                    }
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                }

                new Popover(circle, popoverOptions);
            },
            generatePriceContent(precios) {
                let content = '';

                content += '<ul class="pb-0 mb-0">';
                if (precios && precios.length > 0) {
                    precios.forEach(precio => {
                        content += `<li>${precio.description}: ${this.$n(precio.precio, "currency")}</li>`;
                    });
                } else {
                    content += '<li>No tiene precios configurados</li>'
                }
                content += '</ul>';

                return content;
            },
            label({
                description,
                precio,
                price_management_taquilla_interno,
                price_management_taquilla
            }) {
                var total = parseFloat(precio) + price_management_taquilla

                if (price_management_taquilla_interno == 1) {
                    return (
                        description +
                        ' - (' +
                        parseFloat(precio).toFixed(2) +
                        '€' +
                        ')'
                    )
                } else {
                    return (
                        description +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    )
                }
            },
            showModalEntradas(precios) {
                this.preciosSeleccionados = precios;
                this.showModalRegionSinNumerar = true;

                this.$nextTick(() => {
                    this.$modal.show('modal-region-sin-numerar');
                })
            },
            showModalBloquearButacas() {
                this.$modal.show('bloquearButacas');
            },
            closeModalBloquearButacas() {
                this.$modal.hide('bloquearButacas');
            },
            closeModal() {
                this.showModalRegionSinNumerar = false;
            },
            checkDisponibilidad(butaca) {
                var disponible = butaca.libre;

                if (!disponible && butaca.ocupada) {
                    if (butaca.ocupada.bloqueada && (butaca.ocupada.reserva_id == null && !butaca.ocupada.venta && !butaca.ocupada.sesion && !butaca.ocupada.evento_venta && !butaca.ocupada.evento_sesion && !butaca.ocupada.renovado && !butaca.ocupada.evento_bloqueo)) {
                        disponible = true;
                    }
                }

                return disponible;
            },
            updateLoading(estado) {
                this.$emit('updateLoading', estado);
            },
            bloquearButacasManual(concepto, etiqueta) {
                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    recinto_id: this.recinto_id,
                    butacas: this.butacasSeleccionadas.map(butaca => butaca.id),
                    concepto: concepto,
                };

                if(etiqueta){
                    params.etiqueta_bloqueo_id = etiqueta.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos.general'), params).then(res => {
                    this.getButacas();
                    this.butacasSeleccionadas = [];
                    this.closeModalBloquearButacas();
                    this.$toast.success('Butacas bloqueadas/liberadas correctamente');
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            crearCarrito() {
                const params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                })
            },
            setItemsCarrito() {
                this.disableButtonCart = true;

                const params = {
                    filters: {},
                    cart_id: this.carrito?.id,
                    plazas: this.getPlazasFormatted(),
                    asientos: []
                };

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO');
                    this.$router.push({path: "/admin/eventos"});

                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.disableButtonCart = false;
                });
            },
            getPlazasFormatted() {
                let plazas = [];

                this.butacasSeleccionadas.map(plaza => {
                    plazas.push({
                        precio: {
                            id: plaza.precios[0].id
                        },
                        id: plaza.id,
                        event_id: this.evento_id,
                        event_session_id: this.sesion_id,
                        region_id: plaza.region_id
                    })
                });

                return plazas;
            }
        },
        computed: {
            evento_id() {
                return this.$route?.params?.evento_id ?? null;
            },
            textoVisibilidadReducida() {
                return this.$t(claveVisibilidad('visibilidad_reducida.nombre', this.sesion_id, clave => this.$te(clave)));
            },
            sesion_id() {
                return this.$route?.params?.sesion_id ?? null;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivo;
            }
        },
        watch: {
            paso_activo(estaActivo) {
                if (!estaActivo) {
                    this.renderLeafletSvg(this.svg);
                }
            },
        },
        created() {
            this.getButacas();
            this.getRegionesSinNumerar();
        },
        components: {
            LeafletComponent, ModalRegionSinNumerar, LeyendaColorEventos, TusPlazasComponent, BloquearButacas
        }
    }
</script>